<pipeline-post-footer-default [content]="content" [post]="post" [view]="view"></pipeline-post-footer-default>
<pipeline-post-footer-video [content]="content" [post]="post" [view]="view"></pipeline-post-footer-video>